<template>
  <BaseDashboardLayout>
    <template v-slot:title>
      <h4 class="title mb-5">Work Area</h4>
    </template>

    <div class="row" style="margin-bottom: 6rem">
      <div class="col-md-8">
        <p class="text-muted">This is the area you are prepared to travel for work and ensures you receive relevant leads.</p>

        <div class="card mb-4">
          <div class="card-body">
            <!-- Search input -->
            <div class="form-group mb-4">
              <label for="citySearch" class="fw-bold mb-2">Current location</label>
              <div class="d-flex align-items-center">
                <!-- Places API (New) PlaceAutocompleteElement mounted at runtime (replaces legacy places.Autocomplete). -->
                <div
                    id="citySearch"
                    ref="autocompleteEl"
                    class="places-autocomplete-wrap me-3"
                    style="flex: 1;"
                ></div>
                <div style="width: 1px; height: 38px; background-color: #ddd;"></div> <!-- vertical divider -->
                <input
                    type="text"
                    class="form-control ms-3"
                    :value="user.parishName"
                    disabled
                    placeholder="Parish"
                    style="width: 150px; background-color: #f8f9fa; border-color: #ddd;"
                >
              </div>
            </div>


            <div class="form-group">
              <label for="radiusSelect" class="fw-bold mb-2">Distance area</label>
              <select id="radiusSelect" class="form-control" v-model="radius">
                <option :value="radius" disabled>{{radius}} miles</option>
                <option :value="5">5 miles</option>
                <option :value="10">10 miles</option>
                <option :value="15">15 miles</option>
                <option :value="20">20 miles</option>
                <option :value="25">25 miles</option>
                <option :value="50">50 miles</option>
                <option :value="100">I work throughout Jamaica</option>
              </select>
            </div>

          </div>
        </div>

        <h6 class="fw-bold">Drag the pin to adjust your working distance</h6>
        <gmap-map :center="center" :zoom="10" style="width: 100%; height: 400px" :options="mapOptions">
          <gmap-circle :center="center" :radius="radius * 1609.34" :options="circleOptions"></gmap-circle>
          <gmap-marker :position="center" :draggable="true" @dragend="updateCenter"></gmap-marker>
        </gmap-map>

        <div class="col-12 mt-4">
          <button class="btn primry-btn-2 d-inline-block text-light big-button" @click="save" :disabled="isLoading">
            <b-spinner small v-if="isLoading"></b-spinner>
            {{ isLoading ? 'Saving' : 'Save Changes' }}
          </button>
        </div>

      </div>
    </div>

  </BaseDashboardLayout>
</template>

<script>
import BaseDashboardLayout from '../../base-layout/tradesperson-dashboard';
import appConfig from "../../../../app.config.json";
import {gmapApi} from 'vue2-google-maps';
import {userService} from "@/apis/user.service";

export default {
  name: "WorkArea",
  page: {
    title: "Work Area",
    meta: [{name: "description", content: appConfig.description}]
  },
  data() {
    return {
      isLoading: false,
      center: {lat: 18.1096, lng: -77.2975},
      radius: 10,
      workThroughoutJamaica: false,
      city:'',
      mapOptions: {
        restriction: {
          latLngBounds: {
            north: 18.6000,
            south: 17.7000,
            west: -78.5000,
            east: -76.0000
          },
          strictBounds: true
        }
      },
      circleOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
      },
      user: {
        cityName: '',
        parishName: ''
      }
    };
  },
  computed: {
    google: gmapApi,
  },
  watch: {
    workThroughoutJamaica(newValue) {
      if (newValue) {
        this.radius = 100;
      } else {
        this.radius = 10;
      }
    },
    radius(newValue) {
      if (newValue !== 100) {
        this.workThroughoutJamaica = false;
      }
    }
  },
  methods: {
    updateCenter(location) {
      this.center = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
      this.reverseGeocode(this.center.lat, this.center.lng);
    },
    reverseGeocode(lat, lng) {
      if (!this.google) return;
      const geocoder = new this.google.maps.Geocoder();
      const latlng = { lat, lng };

      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === 'OK' && results[0]) {
          const addressComponents = results[0].address_components;

          const cityComponent = addressComponents.find(comp =>
              comp.types.includes('locality')
          );
          const parishComponent = addressComponents.find(comp =>
              comp.types.includes('administrative_area_level_1')
          );

          this.user.cityName = cityComponent ? cityComponent.long_name : '';
          this.user.parishName = parishComponent ? parishComponent.long_name : '';

        } else {
          console.log('Reverse geocoding failed:', status);
        }
      });
    },

    async initAutocomplete() {
      // Places API (New): mount a PlaceAutocompleteElement (replaces the legacy
      // google.maps.places.Autocomplete, blocked for keys created after 2025-03-01).
      await this.$gmapApiPromiseLazy();
      let PlaceAutocompleteElement;
      if (google.maps.importLibrary) {
        ({PlaceAutocompleteElement} = await google.maps.importLibrary('places'));
      } else {
        PlaceAutocompleteElement = google.maps.places && google.maps.places.PlaceAutocompleteElement;
      }
      const container = this.$refs.autocompleteEl;
      if (!container) return;
      if (!PlaceAutocompleteElement) {
        console.error('PlaceAutocompleteElement unavailable — check Maps JS v=weekly and that "Places API (New)" is enabled.');
        return;
      }
      container.innerHTML = '';
      const pac = new PlaceAutocompleteElement({
        includedRegionCodes: ['jm'],
        includedPrimaryTypes: ['locality', 'sublocality', 'administrative_area_level_3', 'postal_town'],
      });
      pac.setAttribute('placeholder', 'Enter city name');
      pac.style.width = '100%';
      container.appendChild(pac);
      const onSelect = async (event) => {
        let place = event.place;
        if (!place && event.placePrediction && event.placePrediction.toPlace) {
          place = event.placePrediction.toPlace();
        }
        if (!place) return;
        await place.fetchFields({fields: ['location']});
        const loc = place.location;
        if (!loc) return;
        this.center = {lat: loc.lat(), lng: loc.lng()};
        this.reverseGeocode(this.center.lat, this.center.lng);
      };
      pac.addEventListener('gmp-select', onSelect);
      pac.addEventListener('gmp-placeselect', onSelect);
    },

    getUserInfo() {
      userService.getUserInfo().then((res) => {
        const {status, message, extra} = res;
        if (!status) {
          this.$store.dispatch('error', {message: message, showSwal: true});
          return;
        }
        const user = extra;
        if (user.latitude && user.longitude) {
          this.center = {
            lat: parseFloat(user.latitude),
            lng: parseFloat(user.longitude),
          };
        }
        this.user.cityName = user.city || ''
        this.user.parishName = user.parish || ''
        this.radius = user.travel_radius || 10;
      });
    },

    async save() {
      this.isLoading = true;
      userService.workArea({
        travel_radius: this.radius,
        latitude: this.center.lat,
        longitude: this.center.lng,
        city_name: this.user.cityName,
        parish_name: this.user.parishName
      }).then((res) => {
        this.isLoading = false;
        const {status, message, extra} = res;
        if (!status) {
          this.$store.dispatch('error', {message: message, showSwal: true});
          return;
        }
        this.$store.dispatch('updateUserInfo', extra)
        this.$store.dispatch('success', {message: message, showSwal: true});

      });
    },
  },
  components: {
    BaseDashboardLayout,
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    $('#work-area').addClass('active');
    this.$nextTick(() => this.initAutocomplete());
  },
};
</script>

<style scoped>
.form-control:focus {
  font-weight: lighter !important;
}

.form-control{
  font-weight: lighter !important;
}
</style>
